import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Link,
  Toolbar,
  Typography,
} from "@mui/material";
import Logo from "../../general/Logo";

const navLinks = [
  { label: "Our Services", href: "/#services" },
  { label: "Who We Work With", href: "/#clients" },
  { label: "How We Work", href: "/#process" },
  { label: "About Us", href: "/#about" },
  { label: "Contact", href: "/#contact" },
];

const Navbar = () => (
  <AppBar
    elevation={0}
    sx={{
      backgroundColor: "background.paper",
      color: "text.primary",
    }}
  >
    <Toolbar sx={{ minHeight: 64 }}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Logo size={30} to="/" />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            alignItems: "center",
            display: {
              md: "flex",
              xs: "none",
            },
            gap: 1,
          }}
        >
        {navLinks.map(({ label, href }) => (
          <Link
            key={href}
            href={href}
            color="text.primary"
            underline="hover"
            sx={{ px: 1.5 }}
          >
            <Typography variant="body2">{label}</Typography>
          </Link>
        ))}
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: 24,
            mx: 1,
          }}
        />
        <Button
          color="primary"
          component="a"
          href="/app"
          size="small"
          variant="contained"
        >
          Login
        </Button>
      </Box>
      </Container>
    </Toolbar>
    <Divider />
  </AppBar>
);

export default Navbar;
